import { SeasonGroup, Species } from '@omniafishing/core';
import classNames from 'classnames';
import React from 'react';
import { SpanLink } from '../span_link/span_link';
import styles from './season_species_header_tag.less';

interface SeasonSpeciesHeaderTagProps {
  isSticky: boolean;
  selectedSpecies: Species;
  selectedSeasonGroup: SeasonGroup;
  scrollToSelectsSection?: () => void;
}

export const SeasonSpeciesHeaderTag = (props: SeasonSpeciesHeaderTagProps) => {
  const { isSticky, selectedSpecies, selectedSeasonGroup, scrollToSelectsSection } = props;
  return (
    <div
      className={classNames(styles.seasonSpeciesLine, {
        [styles.seasonSpeciesLine__sticky]: isSticky,
      })}
    >
      <span>
        {selectedSpecies.image && <img src={selectedSpecies.image} />}
        <span> {selectedSpecies.display_name}</span>
      </span>
      <span>
        <span className={classNames(styles.seasonIcon, styles[selectedSeasonGroup.name])}></span>
        <span className={styles.seasonGroup}>{selectedSeasonGroup.display_name}</span>
      </span>

      <SpanLink
        className={styles.changeSeasonSpeciesLink}
        onClick={scrollToSelectsSection}
        underline
      >
        Change
      </SpanLink>
    </div>
  );
};
